import axios from "axios";
import api from "./api.js";

const REWARDS_HUB_API_BASE = "https://efu-life.discountworld.net/api/v1";

export const rewardsHubService = {

    login: async (consumerId, phone) => {
        try {
            const payload = {
                consumer_id: consumerId,
                phone: phone,
            };

            const response = await axios.post(
                `${REWARDS_HUB_API_BASE}/efu-login`,
                payload,
                {
                    headers: {
                        "Content-Type": "application/json",
                        "company-id": 5,
                        "Authorization": "AAGxgVnN1MF7OHO7pfBCs2tG0kUK3qrnNfDxgPvR"
                    },
                }
            );

            return response.data;
        } catch (error) {
            console.error("RewardsHub login error:", error);
            throw error;
        }
    },


    getRedeemedHistory: async (accessToken) => {
        try {
            const response = await axios.post(
                `${REWARDS_HUB_API_BASE}/offers/get-redeemed-history`,
                {}, // empty body as API expects POST with headers
                {
                    headers: {
                        "Content-Type": "application/json",
                        "company-id": 5,
                        "Authorization": `Bearer ${accessToken}`,
                    },
                }
            );

            return response.data;
        } catch (error) {
            console.error("RewardsHub get redeemed history error:", error.response || error);
            throw error;
        }
    },


    getCoinsHistory: async (page = 1, limit = 3) => {
        try {
            const response = await api.get(
                `/dw/coinshistory?page=${page}&limit=${limit}`
            );

            return response.data;
        } catch (error) {
            console.error("RewardsHub get coins history error:", error);
            throw error;
        }
    },

    getAllOffers: async (accessToken) => {
        try {
            const response = await axios.get(
                `${REWARDS_HUB_API_BASE}/offers`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        "company-id": 5,
                        "Authorization": `Bearer ${accessToken}`
                    },
                }
            );

            return response.data;
        } catch (error) {
            console.error("RewardsHub get all offers error:", error);
            throw error;
        }
    },

    redeemVoucher: async (offerId, bearerToken, coinsToRedeem) => {
        try {
            const payload = {
                offer_id: offerId,
                bearer_token: bearerToken,
                coins_to_redeem: coinsToRedeem
            };

            const response = await api.post("/dw/redeemvoucher", payload);

            return response.data;
        } catch (error) {
            console.error("RewardsHub redeem voucher error:", error);
            throw error;
        }
    },
}; export default rewardsHubService;